module.exports = "<div class=\"mt-10 mb-10 main-input-item input-search\">\n    <input id=\"search-input\"\n           type=\"text\"\n           class=\"form-control input-search-input\"\n           [formControl]=\"queryField\"\n           placeholder=\"{{placeholder}}\">\n    <label for=\"search-input\" class=\"input-search-label\"></label>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/common/searchbar/searchbar.html
// module id = ./web/modern/components/common/searchbar/searchbar.html
// module chunks = 0